import * as React from 'react';

import Form from 'components/form/Form';
import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';

import './pagination-input.scss';

applyTranslations(require('./pagination-input.i18n.json'));

type Props = {
  pagesTotal: number,
  onUpdate?: (a: number) => void
};

const PaginationInput = (
  {
    pagesTotal,
    onUpdate
  }: Props
): JSX.Element => {
  const [page, setPage] = React.useState('');

  return (
    <div className="pagination-input">
      <span className="pagination-input__label">
        {__t('pagination_input.go_to_page')}
      </span>
      <Form
        onSubmit={() => {
          const newPage = Number(page);

          if (onUpdate && Number.isInteger(newPage)) {
            const clampedPage = Math.min(pagesTotal, Math.max(1, newPage));

            onUpdate(clampedPage);
            setPage('');
          }
        }}
      >
        <Input
          className="pagination-input__form-input"
          onChange={(event) => setPage(event.currentTarget?.value || '')}
          value={page}
        />
      </Form>
      <span className="pagination-input__label">
        {__t('pagination_input.pagination_of', { pagesTotal })}
      </span>
    </div>
  );
};

export default PaginationInput;
